import React from "react";

const LoadingSettlements = () => {

    return (

        <div className="loading-settlements">

            {[1,2,3,4].map(item => (

                <div
                    key={item}
                    className="loading-card"
                />

            ))}

        </div>

    );

};

export default LoadingSettlements;